export function formatPhone(source) {
  return source.replace(/[^0-9+]/gi, '');
}



// WEBPACK FOOTER //
// ./src/components/Contacts/utils.js